module.exports = {"unknownError":"Etwas ist schief gelaufen","close":"Schließen","price":"Preis"}